import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex" }


import MinifigurElement from "@/components/base/MinifigurElement.vue";
import { FigurISaet } from "@/types/legotyper";


export default /*#__PURE__*/_defineComponent({
  __name: 'Minifigurtabel',
  props: {
    figurer: null
  },
  setup(__props: any) {

const props = __props as {
  figurer: FigurISaet[];
}



function antal(antalstreng: string | undefined) {
  return antalstreng === undefined ? undefined : Number(antalstreng);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.figurer, (figur) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "p-3 col-2 shadow-sm",
        key: figur.uuid
      }, [
        _createElementVNode("div", null, [
          _createVNode(MinifigurElement, {
            uuid: figur.uuid,
            "antal-i-saet": antal(figur.setsIndeholderConnection?.edges[0]?.antal)
          }, null, 8, ["uuid", "antal-i-saet"])
        ])
      ]))
    }), 128))
  ]))
}
}

})